import { performLogoutCleanup } from '../authentication/authentication-action';
import React from 'react';
import { HIDE_COMMON_MESSAGE, SHOW_COMMON_MESSAGE, SET_REDIRECT_URL } from '../../action-contants';
import { disableLoader } from '../ui-trigger/ui-trigger-action';
import { ModalFactory } from '../../../components/modal/modal';
import { injectIntoDataLayer, isIframeWindow, showIframeErrorPopup } from '../../../utils/library';
import CommonButton from '../../../components/common-button/CommonButton';
import { FLOW_TYPE_LOGOUT, SESSION_TIMEOUT } from '../../../utils/constants/eventsConstants';
import { store } from '../../../store';
import { get } from 'lodash';
import { setActiveChatAction } from '../help-center-action/help-center-actions';
import { logEvent } from '../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../utils/events/eventsConstants';
import { CAPTCHA_ERROR_MESSAGES } from '@Utils/constants';

export function handleError(
  err,
  is_message_disabled,
  restrict_redirect,
  redirectURL,
  customErrorMessage
) {
  return async (dispatch) => {
    let status;

    if (redirectURL) {
      dispatch(setRedirectURL(redirectURL));
    }
    const errMessage =
      err?.response?.data?.data?.message || err?.response?.data?.data?.data?.message;
    if (err?.response) {
      dispatch(disableLoader());
      status = err?.response?.status;
    } else {
      if (!is_message_disabled) {
        !isIframeWindow()
          ? dispatch(showMessage({ text: ['Something went wrong '], type: 'info' }))
          : showIframeErrorPopup(true, 'Something went wrong');
        return;
      }
    }
    if ([400, 409, 429, 462].includes(status)) {
      if (!is_message_disabled && err?.response?.data?.data) {
        if (errMessage === CAPTCHA_ERROR_MESSAGES.CAPTCHA_ATTEMPT_EXCEEDED_MESSAGE) {
          await confirmPopup(errMessage);
          // clear everything and let the user start afresh
          performLogoutCleanup(dispatch);
          //is_message_disabled will be true for authenticateUser call from unAuth route.
          window.location.href = window.location.origin;
          return;
        }
        if (err?.is3dsFailedError) {
          await confirmPopup(errMessage);
          return;
        } else
          !isIframeWindow()
            ? dispatch(
                showMessage({
                  text: [errMessage],
                  type: 'info'
                })
              )
            : showIframeErrorPopup(true, errMessage);
      }
    } else if (status === 401) {
      if (!is_message_disabled && err?.response?.data?.data) {
        if (errMessage === 'Session Expired. Please Login Again.') {
          const reduxStore = store.getState();
          const countryCode = get(reduxStore, 'rootReducer.userStatusReducer.country_code', '');
          logEvent(SESSION_TIMEOUT, FLOW_TYPE_LOGOUT, { countryCode }, LOG_TYPE.CLEVER_TAP);
        } else if (
          errMessage === CAPTCHA_ERROR_MESSAGES.VISIBLE_CAPTCHA_VERIFICATION_FAILED_MESSAGE
        ) {
          return !isIframeWindow()
            ? dispatch(
                showMessage({
                  text: [errMessage],
                  type: 'info'
                })
              )
            : showIframeErrorPopup(true, errMessage);
        }
        disableZendesk(dispatch);
        dispatch(disableLoader());
        await confirmPopup(errMessage);
      }
      performLogoutCleanup(dispatch);
      //is_message_disabled will be true for authenticateUser call from unAuth route.
      if (!is_message_disabled) window.location.href = window.location.origin;
    } else if (status === 404) {
      if (!is_message_disabled) {
        !isIframeWindow()
          ? dispatch(showMessage({ text: ['404 not found'], type: 'warning' }))
          : showIframeErrorPopup(true, '404 not found');
      }
    } else if (status === 500 && window.location.href.includes('ticket_no')) {
      if (!is_message_disabled) {
        !isIframeWindow()
          ? dispatch(showMessage({ text: [customErrorMessage], type: 'info' }))
          : showIframeErrorPopup(true, customErrorMessage);
      }
    } else if (status === 500 && errMessage) {
      !isIframeWindow()
        ? dispatch(
            showMessage({
              text: [errMessage],
              type: 'info'
            })
          )
        : showIframeErrorPopup(true, errMessage);
    } else {
      if (!is_message_disabled) {
        !isIframeWindow()
          ? dispatch(showMessage({ text: ['Something went wrong !'], type: 'info' }))
          : showIframeErrorPopup(true, 'Something went wrong !');
      }
    }
  };
}

export function showMessage(data) {
  injectIntoDataLayer({ message: data });
  return (dispatch) => {
    dispatch({
      type: SHOW_COMMON_MESSAGE,
      data
    });
  };
}

function setRedirectURL(url) {
  return (dispatch) => dispatch({ type: SET_REDIRECT_URL, data: url });
}

export function hideMessage() {
  return (dispatch) => dispatch({ type: HIDE_COMMON_MESSAGE });
}

const disableZendesk = (dispatch) => {
  const { zE: zenDesk } = window;
  if (zenDesk) {
    zenDesk('messenger', 'logoutUser');
    dispatch(setActiveChatAction(false));
  }
};

function confirmPopup(msg) {
  return ModalFactory.builder(
    (onClose) => (
      <div className="sg-address-doc-modal">
        <div className="message">{msg}</div>
        <CommonButton
          className="session-expired-modal-button"
          text="Ok"
          id="submit"
          onClick={() => {
            sessionStorage.clear();
            onClose(true);
          }}
        />
      </div>
    ),
    'sg-address-confirm insta-modal',
    true
  );
}
